<router-outlet></router-outlet>
@if (showConsent) {
  <app-consent-banner (accepted)="onConsentAccepted()"></app-consent-banner>
}
@if (avisoSenhaFraca) {
  <div class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,.55); z-index: 2000;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-dark text-light border-secondary">
        <div class="modal-header border-secondary">
          <h2 class="modal-title h5 mb-0">Senha fraca</h2>
        </div>
        <div class="modal-body">
          <p class="mb-2">A senha desta conta de administrador não atende à política: no mínimo 8 caracteres, com letra maiúscula, minúscula, número e caractere especial.</p>
          <p class="mb-0">Você ainda pode adiar esta troca {{ adiamentosRestantes }} vez{{ adiamentosRestantes === 1 ? '' : 'es' }}. Depois disso, o próximo login exige a nova senha.</p>
          @if (avisoSenhaErro) {
            <p class="text-warning small mt-3 mb-0">{{ avisoSenhaErro }}</p>
          }
        </div>
        <div class="modal-footer border-secondary">
          <button type="button" class="btn btn-outline-light" [disabled]="adiandoSenha" (click)="deixarSenhaParaDepois()">Deixar para depois</button>
          <button type="button" class="btn btn-primary" (click)="alterarSenhaAgora()">Alterar agora</button>
        </div>
      </div>
    </div>
  </div>
}
